import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectionPositionPair, OverlayModule } from '@angular/cdk/overlay';
import { TranslateModule } from '@ngx-translate/core';
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';
import { CopyIconComponent } from '@itero/ui-toolkit-angular/icons';
import { RxIntuitiveIndicationBadgeComponent } from '@modules/rx-intuitive-teeth-orchestrator/components/rx-intuitive-indication-badge/rx-intuitive-indication-badge.component';
import { IntuitiveCopyFromSourceMenuItem } from '../../models/intuitive-copy-from-source-menu-item';

@Component({
	selector: 'rx-copy-from-tooth-menu',
	templateUrl: './rx-copy-from-tooth-menu.component.html',
	styleUrls: ['./rx-copy-from-tooth-menu.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		CommonModule,
		OverlayModule,
		TranslateModule,
		TlkButtonComponent,
		CopyIconComponent,
		RxIntuitiveIndicationBadgeComponent
	]
})
export class RxCopyFromToothMenuComponent implements OnChanges {
	private static readonly overlayOffsetY = 4;

	@Input() disabled = false;
	@Input() sourceMenuItems: IntuitiveCopyFromSourceMenuItem[] = [];
	@Input() defaultIndicationId = 0;

	@Output() readonly sourceSelected = new EventEmitter<number>();

	readonly overlayViewportMargin = 8;

	readonly overlayPositions: ConnectionPositionPair[] = [
		{
			originX: 'start',
			originY: 'bottom',
			overlayX: 'start',
			overlayY: 'top',
			offsetY: RxCopyFromToothMenuComponent.overlayOffsetY
		},
		{
			originX: 'end',
			originY: 'bottom',
			overlayX: 'end',
			overlayY: 'top',
			offsetY: RxCopyFromToothMenuComponent.overlayOffsetY
		}
	];

	isOpen = false;

	constructor(private readonly changeDetectorRef: ChangeDetectorRef) {}

	get isTriggerDisabled(): boolean {
		return this.disabled || this.sourceMenuItems.length === 0;
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['sourceMenuItems'] && this.sourceMenuItems.length === 0) {
			this.isOpen = false;
		}
	}

	trackByMenuItemToothId(_index: number, item: IntuitiveCopyFromSourceMenuItem): number {
		return item.toothId;
	}

	toggleMenu(event: MouseEvent): void {
		event.stopPropagation();

		if (this.isTriggerDisabled) {
			return;
		}

		this.isOpen = !this.isOpen;
		this.changeDetectorRef.markForCheck();
	}

	onBackdropClick(): void {
		this.isOpen = false;
		this.changeDetectorRef.markForCheck();
	}

	onRowSelected(toothId: number, event: MouseEvent): void {
		event.stopPropagation();
		this.isOpen = false;
		this.changeDetectorRef.markForCheck();
		this.sourceSelected.emit(toothId);
	}
}
